import React from 'react';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { Modal } from 'react-bootstrap';

const FeedBackViewModal = ({ show, close, data }) => {
  return (
    <Modal
      show={show}
      onHide={close}
      contentClassName="border-0"
      centered
      size="lg"
    >
      <Modal.Header className="bg-modal-header light border-bottom-0">
        <FalconCloseButton noOutline onClick={close} />
      </Modal.Header>
      <Modal.Body>
        {data?.map((el, idx) => (
          <fieldset key={idx} className={'form-legend-item-wrapper mb-4'}>
            <legend className="item-title fs-0 fw-semi-bold">
              {el.question}
            </legend>
            <p className="py-3 px-5">{el.answer}</p>
          </fieldset>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default FeedBackViewModal;
